import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenIcon } from 'lucide-react';
export function Hook() {
  return <section className="py-20 md:py-28 bg-parchment relative" data-id="element-138">
      <div className="container mx-auto px-4" data-id="element-139">
        <div className="max-w-3xl mx-auto text-center" data-id="element-140">
          <FadeIn data-id="element-141">
            <div className="flex justify-center mb-8" data-id="element-142">
              <BookOpenIcon className="w-12 h-12 text-gold" strokeWidth={1.5} data-id="element-143" />
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-144">
            <p className="text-xl md:text-2xl lg:text-3xl font-serif text-ink leading-relaxed mb-8" data-id="element-145">
              "¿Alguna vez has sentido que, por más que oras y ayunas, tu cuenta
              bancaria sigue gritando{' '}
              <span className="italic text-red-800/80" data-id="element-146">escasez</span>?"
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-147">
            <p className="text-lg md:text-xl text-charcoal leading-relaxed mb-6" data-id="element-148">
              No es que Dios no te escuche, es que no estás siguiendo el
              protocolo legal que Él mismo dejó escrito para Sus hijos.
            </p>
            <p className="text-lg md:text-xl text-charcoal leading-relaxed" data-id="element-149">
              La mayoría de los creyentes viven en un ciclo de "supervivencia
              espiritual" porque intentan pedir lo que ya les pertenece, sin
              presentar una visión clara que el cielo pueda respaldar.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}